import { postCTA } from '../../../../../../utils/appBridge'
import { getMutualFundDetailCTA } from '../../../../../../utils/commonAppCTAs'
import { LumpsumRecommendationActionType } from '../../api/common.types'
import { PlanCategoryBucketKey, type PlansPlanMode } from '../../api/types'

export type IdealPlanRecommendationOpenParams = {
  isin: string
  planMode?: PlansPlanMode
  bucketType?: PlanCategoryBucketKey
}

export type PlanRecommendationOpenParams = {
  isin: string
  planMode?: PlansPlanMode
  bucketType: PlanCategoryBucketKey
  recommendationAction?: LumpsumRecommendationActionType
}

const PLAN_RECOMMENDATION_BOTTOM_SHEET_BUCKET_KEYS = new Set<PlanCategoryBucketKey>([
  PlanCategoryBucketKey.buyRecommendations,
  PlanCategoryBucketKey.sellRecommendations,
  PlanCategoryBucketKey.executedRecommendations
])

export function isPlanRecommendationBottomSheetBucket(
  bucketType?: PlanCategoryBucketKey
): bucketType is PlanCategoryBucketKey {
  return bucketType != null && PLAN_RECOMMENDATION_BOTTOM_SHEET_BUCKET_KEYS.has(bucketType)
}

export function resolveRecommendationAction(
  bucketType?: PlanCategoryBucketKey,
  recommendationAction?: LumpsumRecommendationActionType
): LumpsumRecommendationActionType | undefined {
  if (recommendationAction) {
    return recommendationAction
  }
  if (bucketType === PlanCategoryBucketKey.buyRecommendations) {
    return LumpsumRecommendationActionType.BUY
  }
  if (bucketType === PlanCategoryBucketKey.sellRecommendations) {
    return LumpsumRecommendationActionType.SELL
  }
  return undefined
}

export function resolveSellLedPlanSwitchHeadlineSuffix(buyFundCount: number): string {
  if (buyFundCount <= 1) {
    return ' from your current fund'
  }
  return ' to the new funds'
}

export function openRecommendationFundDetail(isin: string) {
  const fundIsin = isin?.trim() ?? ''
  if (fundIsin.length === 0) {
    return
  }
  postCTA(JSON.stringify(getMutualFundDetailCTA({ isin: fundIsin, navigationStyle: 'PUSH' })))
}
